import { useEffect, useState } from 'react';
import { FaBars, FaShoppingCart, FaUser } from 'react-icons/fa';
import './TopBar.scss';
import { getPersonNameFirstLast } from '../../utils/NameHelper';
import { EmployeeDetail } from '../../types/api/employees/EmployeeDetail';
import { Nullable } from '../../types/custom/Nullable';
import { permissionsService } from '../../utils/PermissionService';
import { UserDetail } from '../../types/api/users/UserDetail';
import { Button, Nav, Navbar } from 'react-bootstrap';
import { toggleSideNav } from '../../actions/SideNavActions';
import { useReduxDispatch } from '../../hooks/redux/useReduxDispatch';
import { toggleCart } from '../../actions/CartActions';
import { useRouteMatch } from 'react-router-dom';
import { shouldCartBeVisible } from '../../utils/CartHelper';
import { useWolfTracsState } from '../../hooks/redux/useWolfTracsState';
import { PackageType } from '../../types/enums/PackageType';

export const TopBar = () => {
	const [ person, setPerson ] = useState<Nullable<EmployeeDetail>>(null);
	const [ user, setUser ] = useState<Nullable<UserDetail>>(null);
	const dispatch = useReduxDispatch();
	const match = useRouteMatch('/packages/:packageId');
	const isCartVisible = shouldCartBeVisible();

	const { isAuthenticated } = useWolfTracsState(s => s.account);
	const { data: activePackage } = useWolfTracsState(s => s.packages.activePackage);

	// Note: This "is authenticated" stuff is kind of a hack. I (stupidly) designed the original permission / user service because I didn't understand redux.
	// Technically the permission service should die and this info should just be pulled out of redux rather than my little static class.

	// Making this code only run "if authenticated" at least means that the top bar won't prematurely fire its own api calls to access the user info.
	useEffect(() => {
		const getUserDetails = async() => {
			try {
				const result = await permissionsService.getCurrentUser();
				setUser(result);
				const person = await permissionsService.getCurrentPerson();
				if(person) {
					setPerson(person);
				}
			}
			catch {
				console.error('Error loading user data.');
			}
		};
		if (isAuthenticated) {
			getUserDetails();
		}
	}, [isAuthenticated]);

	const renderUserNameDisplay = () => {
		if (activePackage?.packageTypeId === PackageType.PublicEnrollment) {
			return 'Public Enrollment Session';
		}

		const userName = user?.name ?? null;
		const personName = person ? getPersonNameFirstLast(person) : null;

		// I'm going for this format:
		// User Name | Person Name
		let displayText = userName;

		// Only add the pipe if there is a person currently and the names aren't identical.
		if(personName !== null && personName !== displayText) {
			displayText = `${displayText} | ${personName}`;
		}

		return displayText;
	};

	return (
		<Navbar bg="wt-blue" fixed="top" className="top-nav-bar">
			<Button className="side-nav-controller" onClick={() => dispatch(toggleSideNav())}><FaBars /></Button>
			<Navbar.Brand href="/" className="logo-display">
				<img
					src="/media/logo_solo.png"
					className="d-inline-block align-top top-nav-small-display"
					alt="WolfTracs logo"
				/>
				<img
					src="/media/logo_solo_on.png"
					className="d-inline-block align-top top-nav-small-hover"
					alt="WolfTracs logo"
				/>
				<img
					src="/media/wolftracs_logo.png"
					className="d-inline-block align-top top-nav-logo-display"
					alt="WolfTracs logo"
				/>
				<img 
					src="/media/wolftracs_logo_on.png" 
					className="d-inline-block align-top top-nav-logo-hover" 
					alt="WolfTracs logo" 
				/>
			</Navbar.Brand>
			<Nav className="ml-auto">
				<Nav.Link href="#Users"><span className="d-none d-sm-none d-md-inline-block">{renderUserNameDisplay()}</span> <FaUser /></Nav.Link>
			</Nav>
			{match && <Button onClick={() => dispatch(toggleCart())} type="button" className="ml-1 cart-nav" disabled={!isCartVisible}><FaShoppingCart /> Cart</Button>}
		</Navbar>
	);
};